// Basic
import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
// Components
import Page from '@/common-utils/components/structure/page/Page';
import TransactionsTable from '@/app/modules/remoteCollections/components/tables/TransactionsTable';
// Common
import RouteUrls from '../../enums/RouteUrls';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';
import { extractQueriesFromUrl } from '@/common-utils/functions/restUtils';
import { REMOTE_COLLECTION } from '@/app/modules/remoteCollections/api/apiUrls';
import Permissions from '@/app/permissions/Permissions';

/**
 * @returns {JSX} RemoteCollectionDetails
 */
function RemoteCollectionDetails() {

    // URL Params
    const { remoteCollectionId } = useParams();
    const location = useLocation();
    const { posTerminalId } = extractQueriesFromUrl(location.search);

    // State
    const [i18nData, setI18nData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    // Constants
    const exportProps = {
        permissions: [
            Permissions.EXPORT_POS_TERMINAL_TRANSACTIONS.name
        ],
        api: REMOTE_COLLECTION.EXPORT_TRANSACTIONS,
        uuid: remoteCollectionId,
        query: { posTerminalUuid: posTerminalId }
    };

    return (
        <Page>
            <Page.Header
                route={RouteUrls.REMOTE_COLLECTION_TRANSACTIONS}
                i18nData={i18nData}
                isLoading={isLoading}
                routeBase={RouteUrls.REMOTE_COLLECTION}
            />
            <Page.Body>
                <TransactionsTable
                    filtersEventName={setFiltersEventName('transactions')}
                    remoteCollectionId={remoteCollectionId}
                    posTerminalId={posTerminalId}
                    setData={setI18nData}
                    setIsLoading={setIsLoading}
                    exportProps={exportProps}
                />
            </Page.Body>
        </Page >
    );
}

export default RemoteCollectionDetails;